import styled from 'styled-components';

export const Bar = styled.div`
  width: 217px;
  margin-top: 22px;

  p {
    color: ${({ theme: { colors }, dark }) =>
      dark ? colors.darkGrey : colors.white};
    margin-bottom: 5px;
  }

  .progress-bar {
    position: relative;
    width: 100%;
    height: 2px;
    background-color: ${({ dark }) =>
      dark ? 'rgba(0, 0, 0, 0.4)' : 'rgba(255, 255, 255, 0.4)'};

    &--completed {
      position: absolute;
      top: 0;
      left: 0;
      width: 33.33%;
      height: 2px;
      background-color: ${({ theme: { colors }, dark }) =>
        dark ? colors.darkGrey : colors.white};
      transition: 0.3s all;
    }
  }

  .navigation {
    display: flex;
    justify-content: space-between;
    padding-top: 6px;

    button {
      background: unset;
      background-color: unset;
      padding: 0;
      margin: 0;
      border: 0;
      outline: 0;
      color: ${({ theme: { colors }, dark }) =>
        dark ? colors.darkGrey : colors.white};
      font-size: 12px;
      letter-spacing: 0.13px;
      line-height: 22px;
      opacity: 0.4;
      display: inline-block;

      &:hover {
        opacity: 1;
      }
    }
  }
`;
